import { Divider, Typography, makeStyles } from "@material-ui/core";
import React, { Fragment, useEffect, useMemo } from "react";
import {
  ReferenceInput,
  TextField,
  usePermissions,
  useTranslate,
} from "react-admin";

import AutocompleteInput from "./AutocompleteInput";
import { get } from "lodash";
import { useFieldLabel } from "ra-friendsofbabba";
import { useForm } from "react-final-form";

const optionText = (record) => `${record.code} - ${record.name}`;
const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 275,
    "& h5, & .MuiTypography-body1": {
      paddingTop: theme.spacing(1),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingBottom: theme.spacing(1),
    },
    "& .MuiTypography-caption": {
      paddingTop: theme.spacing(2),
      fontWeight: "bold",
    },
  },
}));

const ProjectProposalDetails = ({ selected }) => {
  const classes = useStyles();
  const translate = useTranslate();
  return (
    <div className={classes.root}>
      <Typography variant="h5" component="h5" gutterBottom>
        {get(selected, "code")} {" - "} {get(selected, "name")}
      </Typography>
      <Divider />
      <Typography variant="body1" component="p">
        <Typography variant="caption">
          {translate("resources.project-proposals.fields.description")}
        </Typography>
        <br />
        <TextField source="description" record={selected} />
        <br />
        <Typography variant="caption">
          {translate("resources.scientific-disciplinary-sectors.name")}
        </Typography>
        <br />
        <TextField
          source="project_idea.scientific_disciplinary_sector.fullname"
          record={selected}
        />
        <br />
        <Typography variant="caption">
          {translate("resources.project-ideas.name", { smart_count: 1 })}
        </Typography>
        <br />
        <TextField
          variant="subtitle2"
          source="project_idea.code"
          record={selected}
        />
        {" - "}
        <TextField
          variant="subtitle2"
          source="project_idea.title"
          record={selected}
        />
        <br />
        <Typography variant="caption">
          {translate("resources.universities.name", { smart_count: 0 })}
        </Typography>
        <br />
        <TextField
          variant="subtitle2"
          source="project_idea.university.name"
          record={selected}
        />
        <br />
        <Typography variant="caption">
          {translate("resources.university-departments.name", {
            smart_count: 0,
          })}
        </Typography>
        <br />
        <TextField
          variant="subtitle2"
          source="project_idea.university_department.name"
          record={selected}
        />
      </Typography>
    </div>
  );
};

const ProjectProposalWrapper = (props) => {
  const form = useForm();
  const {
    input: { value },
    choices,
  } = props;
  const selected = useMemo(
    () => choices.find((c) => c.id === value),
    [choices, value]
  );
  useEffect(() => {
    form.change(
      "user.profile.university_id",
      get(selected, "project_idea.university_id")
    );
    form.change(
      "user.profile.university_department_id",
      get(selected, "project_idea.university_department_id")
    );
  }, [form, selected]);
  return (
    <Fragment>
      <AutocompleteInput {...props} optionText={optionText} />
      {selected && <ProjectProposalDetails selected={selected} />}
    </Fragment>
  );
};

const ProjectProposalInput = ({ project_proposal, ...props }) => {
  const fieldLabel = useFieldLabel({ ...props });
  const { loaded, permissions } = usePermissions();
  const isAdmin = loaded && permissions(["admin"]);
  const project_proposal_id = get(props, `record.${project_proposal}.id`, null);
  if (isAdmin && project_proposal_id === null) {
    return (
      <Fragment>
        <ReferenceInput
          {...props}
          reference="project-proposals"
          label={fieldLabel(props.source)}
          sort={{
            field: "code",
            order: "ASC",
          }}
          perPage={1000}
        >
          <ProjectProposalWrapper />
        </ReferenceInput>
      </Fragment>
    );
  }

  return (
    <ProjectProposalDetails
      selected={get(props, `record.${project_proposal}`)}
    />
  );
};
export default ProjectProposalInput;
